import { Component, Input, OnInit } from '@angular/core';
import { remindersListing } from 'src/app/core/interfaces/reminder.interface';

@Component({
  selector: 'app-reminder-list',
  templateUrl: './reminder-list.component.html',
  styleUrls: ['./reminder-list.component.sass']
})


export class ReminderListComponent implements OnInit {

  @Input() reminders:remindersListing[];

  constructor() { }

  ngOnInit(): void {
  }

}
